var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDance4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 569,
    viewBox: "0 0 323 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2120_10880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3412 568.621C142.078 568.621 180.868 548.346 195.342 515.906L201.132 561.67H247.448V383.827C247.448 307.361 199.974 270.287 129.921 270.287C56.9726 270.287 8.34058 309.099 8.34058 368.187H55.8146C55.8146 334.009 81.8674 313.733 127.605 313.733C165.816 313.733 194.184 330.533 194.184 378.035V386.145L105.026 393.096C38.4461 398.31 -0.34375 430.75 -0.34375 482.886C-0.34375 534.443 35.5513 568.621 96.3412 568.621ZM111.973 526.333C76.657 526.333 54.6569 511.271 54.6569 481.148C54.6569 453.342 74.3412 434.805 122.394 430.171L194.763 424.378V439.439C194.763 492.734 163.5 526.333 111.973 526.333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2120_10880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 569,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDance4);
export default __webpack_public_path__ + "static/media/dance4.a43e5202a131441481fd9792cbd1df45.svg";
export { ForwardRef as ReactComponent };